export const changePassword = {
    title: 'Đổi mật khẩu',
    oldPasswordLabel: 'Mật khẩu cũ',
    newPasswordLabel: 'Mật khẩu mới',
    confirmPasswordLabel: 'Nhập lại mật khẩu mới',
    password: 'Mật khẩu',
    save: 'Lưu thay đổi',
    cancel: 'Hủy',
};
